import { createSelector } from '@reduxjs/toolkit';
import { emptyArr, emptyObj } from '@beef/utils';
import { createCurrentModule, createCurrentSelector } from '@beef/redux';
import { TARIFF_TYPES } from "../../../constants/types";
import { getIsAuthFlag } from "./shared";
import { createMergedBlockSelector, getModulesData } from "../catalogSelectors";
import { getTariffsBlock } from "../catalogBlocksSelectors";
import { getOrderTariffCommonData } from "./orderTariffCommon";
var getTariffsState = function getTariffsState(state) {
  return getModulesData(state).tariffs || emptyObj;
};
var getTariffsData = createMergedBlockSelector(getTariffsBlock);
var getTariffsLink = function getTariffsLink(state) {
  return getTariffsData(state).link || emptyObj;
};
var getTariffTabsSettings = function getTariffTabsSettings(state) {
  return getTariffsData(state).tabsSettings || emptyObj;
};
export var getPresetUpFToggleFlag = function getPresetUpFToggleFlag(state) {
  return getOrderTariffCommonData(state).showPresetUpCheckAddress;
};
export var selectPresetUpCallbackFormFlag = function selectPresetUpCallbackFormFlag(state) {
  return getOrderTariffCommonData(state).showPresetUpCallbackForm;
};
export var getShowOnlyRouterInAlternativeUpTariff = function getShowOnlyRouterInAlternativeUpTariff(state) {
  return getOrderTariffCommonData(state).showOnlyRouterInAlternativeUpTariff;
};
export var getTariffsGroup = function getTariffsGroup(state) {
  return getTariffsState(state).group;
};
export var getTariffsTitle = function getTariffsTitle(state) {
  return getTariffsData(state).title;
};
export var getTariffsHref = function getTariffsHref(state) {
  return getTariffsLink(state).href;
};
export var getTariffsTextLink = function getTariffsTextLink(state) {
  return getTariffsLink(state).textLink;
};
export var getTariffTabsList = function getTariffTabsList(state) {
  return (getTariffTabsSettings(state).tabs || emptyArr).map(function (_ref) {
    var key = _ref.key,
      title = _ref.content.title;
    return {
      title: title,
      id: key
    };
  });
};
export var getTariffValueGroups = function getTariffValueGroups(state) {
  return getTariffsData(state).valueGroups || emptyArr;
};
export var getDataRouter = function getDataRouter(state) {
  return getTariffsData(state).router || emptyObj;
};
export var getTariffsList = function getTariffsList(state) {
  var _Object$values;
  return ((_Object$values = Object.values(getGroupedTariffsList(state))) === null || _Object$values === void 0 ? void 0 : _Object$values.flat()) || emptyArr;
};
export var getGroupedTariffsList = function getGroupedTariffsList(state) {
  return getTariffsData(state).tariffs || emptyArr;
};
export var getActiveTariffsIds = createSelector([getGroupedTariffsList, getTariffsGroup], function (tariffs, group) {
  var _tariffs$group;
  return ((_tariffs$group = tariffs[group]) === null || _tariffs$group === void 0 ? void 0 : _tariffs$group.map(function (tariff) {
    return tariff.alias;
  })) || emptyArr;
});
var _createCurrentSelecto = createCurrentSelector(getTariffsList, function (item) {
    return item.alias;
  }),
  __ = _createCurrentSelecto.selectCurrent,
  CurrentTariffProvider = _createCurrentSelecto.CurrentProvider,
  withTariffMapper = _createCurrentSelecto.withCurrentProviderMapper;
export { __, CurrentTariffProvider, withTariffMapper };
var getCurrentTariff = function getCurrentTariff(state) {
  return __(state) || emptyObj;
};
export var getIsLinkFlag = function getIsLinkFlag(state) {
  return getCurrentTariff(state).isLink || false;
};
export var getTariffValues = function getTariffValues(state) {
  return getCurrentTariff(state).values || emptyArr;
};
export var getTariffTitle = function getTariffTitle(state) {
  return getCurrentTariff(state).title;
};
export var getTextColor = function getTextColor(state) {
  return getCurrentTariff(state).textColor;
};
export var getTariffGroup = function getTariffGroup(state) {
  return getCurrentTariff(state).group;
};
export var getTariffInacId = function getTariffInacId(state) {
  return getCurrentTariff(state).inacId;
};
var getIsPresetUpFlag = function getIsPresetUpFlag(state) {
  return getCurrentTariff(state).isPresetUp;
};
export var getTariffImageSrc = function getTariffImageSrc(state) {
  return getCurrentTariff(state).image;
};
export var getTariffImageWidth = function getTariffImageWidth(state) {
  return getCurrentTariff(state).imageWidth;
};
export var getTariffBgColor = function getTariffBgColor(state) {
  return getCurrentTariff(state).bgColor;
};
export var getTariffDescription = function getTariffDescription(state) {
  return getCurrentTariff(state).description;
};
export var getTariffAction = function getTariffAction(state) {
  return getCurrentTariff(state).action;
};
export var getTariffFee = function getTariffFee(state) {
  return getCurrentTariff(state).fee || emptyObj;
};
export var getTariffOldFee = function getTariffOldFee(state) {
  return getCurrentTariff(state).oldFee || emptyObj;
};
export var getTariffUrl = function getTariffUrl(state) {
  return getCurrentTariff(state).detailsUrl;
};
export var getTariffParameters = function getTariffParameters(state) {
  return getCurrentTariff(state).parameters || emptyArr;
};
var getTariffType = function getTariffType(state) {
  return getCurrentTariff(state).type;
};
export var getTariffAlias = function getTariffAlias(state) {
  return getCurrentTariff(state).alias;
};
export var getTariffTags = function getTariffTags(state) {
  return getCurrentTariff(state).tags || emptyArr;
};
export var getTariffIcons = function getTariffIcons(state) {
  return getCurrentTariff(state).icons || emptyArr;
};
export var getIsMyTariff = function getIsMyTariff(state) {
  return getCurrentTariff(state).isConnected;
};
export var getTariffButtonText = function getTariffButtonText(state) {
  return getCurrentTariff(state).buttonText || getTariffsData(state).buttonText;
};

// fixme вынести селекторы в каталог и все зависимости
export var selectIsLoadingTariffButton = function selectIsLoadingTariffButton(state) {
  return getTariffsState(state).tariffButtonLoading;
};
export var selectIsLoadingTariffButtonFlag = createSelector([selectIsLoadingTariffButton, getTariffInacId], function (_ref2, targetInacId) {
  var inacId = _ref2.inacId,
    isLoad = _ref2.isLoad;
  return targetInacId === inacId && isLoad;
});
export var getTariffTypeWithPresetUp = createSelector([getIsPresetUpFlag, getTariffType], function (isPresetUp, type) {
  return isPresetUp ? TARIFF_TYPES.presetUp : type;
});
export var selectHidePointerEventFlag = createSelector([getIsAuthFlag, getTariffTypeWithPresetUp], function (isAuth, type) {
  return isAuth || type === TARIFF_TYPES.partnerFmc;
});
export var TariffModule = createCurrentModule({
  selectTariff: getCurrentTariff
});